import { MortgagePreferences, MortgageType } from "models/ApplicationSummaryEnhanced"
import React from "react"

interface MortgageTypeCopy {
  preference: MortgagePreferences["mortgageType"]
}

export const MortgageTypeCopy = ({ preference }: MortgageTypeCopy) => {
  switch (preference.type) {
    case MortgageType.TrackerMortgage:
      return (
        <>
          A <strong>tracker rate</strong> has been recommended because {preference.customReason}
        </>
      )
    case MortgageType.FixedRateMortgage:
      return (
        <>
          A <strong>fixed rate mortgage</strong> has been recommended because{" "}
          {preference.customReason}
        </>
      )
    default:
      return null
  }
}
